export default "__VITE_ASSET__CRUgzH2g__"